const config = {
  host: `https://${window.location.hostname}/api`,
  // host: `http://${window.location.hostname}:3000/api`,
  // host: 'https://projectstart.cfadesigntechnology.com/api',

  currentRevitVersion: '2024',
};

export default config;

// current vuetify vuetify                      2.2.8
// current vuetify vuetify-loader               1.4.3
// current vue-cli-plugin-vuetify               2.0.3
// current sass                                 1.25.0
